import { Visibility as VisibilityIcon } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { useFormContext } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { useReportCtx } from '../../../report-ctx';

/**
 * Visualize report button. Same style as list-view RefreshButton (outlined, secondary).
 */
export const VisualizeReportBtnRhf = () => {
  const { formState } = useFormContext<{ _format: string }>();
  const ctx = useReportCtx();
  const { $t } = useIntl();

  return (
    <LoadingButton
      type="submit"
      size="small"
      variant="outlined"
      color="secondary"
      loading={ctx.isLoading}
      disabled={!formState.isValid}
      startIcon={<VisibilityIcon />}
    >
      {$t({ id: 'common.visualize', defaultMessage: 'Visualizar' })}
    </LoadingButton>
  );
};
